import { Navigate } from 'react-router';

import { useActiveUser } from '@ll-platform/frontend/core/auth/hooks/useActiveUser';
import { Pages } from '@ll-platform/frontend/core/router/pages';

export const InternalDashboardRedirectController = () => {
  const { activeUser } = useActiveUser();

  return (
    <Navigate
      to={
        activeUser.preferences.internalDashboardDefaultPage ??
        Pages.InternalProjects
      }
      replace
    />
  );
};
